import Repository from "./repository"

export default {
    /**
     * S20402_変更画面表示
     *
     * @param {object} params リクエストパラメータ
     */
    get(params) {
        return Repository.get('/api/s204-chat-contract-changes/view', { params: params })
    },
    /**
     * ChatLuckのご契約内容変更お申し込みを登録する
     *
     * @param {*} params 変更するご契約内容
     * @returns response
     */
    add(params) {
        return Repository.post('/api/s204-chat-contract-changes/add', params)
    }
}